/*eslint @typescript-eslint/no-empty-function: "off" */
/*eslint no-prototype-builtins: "off" */
import { ArrayUnpacked } from './happyTypes';
import { convertNumbersToProperFormat } from './number';
import { useEffect } from 'react';
import { getDomainAndPort } from '../api/Utils';

export const removeDuplicates = <T>(a: T[]) => {
  const prims = { boolean: {}, number: {}, string: {} };
  const objs: any[] = [];

  return a.filter(function (item) {
    const type = typeof item;
    if (type in prims)
      return prims[type].hasOwnProperty(item)
        ? false
        : (prims[type][item] = true);
    else return objs.indexOf(item) >= 0 ? false : objs.push(item);
  });
};

export const removeDuplicateObjectsFromArray = <T>(
  arr: T[],
  uniqueBy: keyof ArrayUnpacked<T[]>
) => {
  const seen = new Set();
  return arr.filter((item) => {
    const isDuplicate = seen.has(item[uniqueBy]);
    seen.add(item[uniqueBy]);
    return !isDuplicate;
  });
};

export const arrayIntoChunks = <T>(arr: T[], chunkSize: number) => {
  const chunks: T[][] = [];
  while (arr.length) {
    chunks.push(arr.splice(0, chunkSize));
  }
  return chunks;
};

export const getRedirectToLoginPath = (reason?: string, message?: string) => {
  if (!reason) reason = '';
  return (
    '/login?' +
    `type=${reason}&` +
    `message=${message || ''}&` +
    `redirect=${encodeURIComponent(
      window.location.pathname + (window.location.search || '?')
    )}`
  );
};
export const getRedirectToLoginLocation = (reason?: string) => {
  if (!reason) reason = 'AccessDenied';
  return (
    window.location.protocol +
    '//' +
    window.location.host +
    (getDomainAndPort().view?.startsWith('public') ? '/_' : '') +
    '/login?redirect=' +
    window.location.pathname +
    (window.location.search || '?') +
    `&type=${reason}`
  );
};

export const getTruthy = <V, D>(value: V, defaultValue: D) => {
  return !isNaN(value as number) && value !== undefined && value !== null
    ? value
    : defaultValue;
};

export const mergeRefs = (...refs: any) => {
  const filteredRefs = refs.filter(Boolean);
  if (!filteredRefs.length) return null;
  if (filteredRefs.length === 0) return filteredRefs[0];
  return (inst: any) => {
    for (const ref of filteredRefs) {
      if (typeof ref === 'function') {
        ref(inst);
      } else if (ref) {
        ref.current = inst;
      }
    }
  };
};

export function distance(
  lon1: number,
  lat1: number,
  lon2: number,
  lat2: number
) {
  const R = 6371; // Radius of the earth in km
  const dLat = ((lat2 - lat1) * Math.PI) / 180; // Javascript functions in radians
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
}

export function formatKM(dist: number) {
  if (dist < 1000) return convertNumbersToProperFormat(dist, 0) + ' متر';
  return (
    convertNumbersToProperFormat(dist / 1000, dist > 10000 ? 0 : 1) +
    ' کیلو‌متر'
  );
}

export function printElement(element: Element) {
  const WinPrint = window.open(
    '',
    '',
    'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0'
  );
  const base = WinPrint!.document.createElement('base');
  base.setAttribute('href', window.location.origin);
  WinPrint?.document.head.append(base);

  document.querySelectorAll('style').forEach((s) => {
    WinPrint?.document.head.append(s.cloneNode(true));
  });
  document.querySelectorAll('link').forEach((s) => {
    WinPrint?.document.head.append(s.cloneNode(true));
  });
  // WinPrint!.location.href = window.location.href;
  WinPrint!.document.dir = 'rtl';
  WinPrint?.document.body.append(element.cloneNode(true));
  WinPrint?.document.close();
  WinPrint?.focus();
  // WinPrint?.print();
  // WinPrint?.close();
}
export function printCalendar(element: Element) {
  const WinPrint = window.open(
    '',
    '',
    'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0'
  );
  const base = WinPrint!.document.createElement('base');
  base.setAttribute('href', window.location.origin);
  WinPrint?.document.head.append(base);

  document.querySelectorAll('style').forEach((s) => {
    WinPrint?.document.head.append(s.cloneNode(true));
  });
  document.querySelectorAll('link').forEach((s) => {
    WinPrint?.document.head.append(s.cloneNode(true));
  });
  // WinPrint!.location.href = window.location.href;
  WinPrint!.document.dir = 'rtl';
  WinPrint?.document.body.append(element.cloneNode(true));
  const tables = WinPrint?.document.body.getElementsByTagName('table');
  if (tables) {
    for (let i = 0; i < tables?.length || 0; i++) {
      const table = tables![i];
      table.classList.add('highlightedTable');
    }
  }
  WinPrint?.document.close();
  WinPrint?.focus();
  // WinPrint?.print();
  // WinPrint?.close();
}

export function getCookie(cname: string) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function setCookie(cname: string, cvalue: string, exdays?: number) {
  let expires = 'Max-Age=315360000;';
  if (exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    expires = 'expires=' + d.toUTCString() + ';';
  }
  document.cookie = cname + '=' + cvalue + ';' + expires + 'path=/';
}

export function duplicateArray(array: any[], n: number = 10) {
  return Array.from({ length: n }, () => [...array]).reduce(
    (current, item) => [...current, ...item],
    []
  );
}

const useRunAtSpecificTime = (
  callback: () => void,
  epochTimeInMilliseconds: number,
  otherDependencies: any[]
): void => {
  useEffect(() => {
    const runAtSpecificTime = (): (() => void) | undefined => {
      const currentTime = new Date().getTime();
      const timeToRun = epochTimeInMilliseconds - currentTime;

      if (timeToRun > 0) {
        const timeout = setTimeout(callback, timeToRun);
        return () => clearTimeout(timeout); // Clean up the timeout if component unmounts before it triggers
      } else {
        return undefined;
      }
    };

    const cleanup = runAtSpecificTime();

    return () => {
      if (cleanup) {
        cleanup(); // Clean up the timeout if the component unmounts before the callback triggers
      }
    };
  }, [callback, epochTimeInMilliseconds, ...otherDependencies]);
};

export default useRunAtSpecificTime;

export function readClipboard(
  then: (content: string) => void,
  promptMessage?: string
) {
  (window.navigator as any).permissions
    .query({ name: 'clipboard-read' })
    .then((result: any) => {
      // If permission to read the clipboard is granted or if the user will
      // be prompted to allow it, we proceed.

      if (result.state === 'granted' || result.state === 'prompt') {
        navigator.clipboard.readText().then(
          (text) => {
            then(text);
          },
          () => {
            const text = window.prompt(promptMessage);
            if (text) then(text);
          }
        );
      } else {
        const text = window.prompt(promptMessage);
        if (text) then(text);
      }
    });
}
export const deepEqual = function (x: any, y: any) {
  if (x === y) {
    return true;
  } else if (
    typeof x === 'object' &&
    x !== null &&
    typeof y === 'object' &&
    y !== null
  ) {
    if (Object.keys(x).length !== Object.keys(y).length) {
      return false;
    }
    for (const prop in x) {
      if (y.hasOwnProperty(prop)) {
        if (!deepEqual(x[prop], y[prop])) {
          return false;
        }
      } else {
        return false;
      }
    }

    return true;
  } else {
    return false;
  }
};

export function isPrefix(query: string, context?: string) {
  return !!context?.startsWith(query);
}

export function arraysEqual(a: any[] | undefined, b: any[] | undefined) {
  if (a === b) return true;
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  if (a.length !== b.length) return false;

  // If you don't care about the order of the elements inside
  // the array, you should sort both arrays here.
  // Please note that calling sort on an array will modify that array.
  // you might want to clone your array first.

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

export function moveItemInArray(
  arr: any[],
  fromIndex: number,
  toIndex: number
) {
  const removed = arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, removed[0]);
}

export function shuffleArray(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}
